const tr = {
  // Header / Navigation
  'nav.sports': 'Spor Bahisleri',
  'nav.live': 'Canlı Bahis',
  'nav.games': 'Oyunlar',
  'nav.promotions': 'Promosyonlar',
  'nav.deposit': 'Para Yatır',
  'nav.myBets': 'Bahislerim',
  'nav.news': 'Haberler',
  'nav.account': 'Hesap',
  'nav.login': 'Giriş Yap',
  'nav.register': 'Kayıt Ol',
  'nav.logout': 'Çıkış Yap',

  // Login
  'login.welcome': 'Hoş Geldiniz',
  'login.noAccount': 'Hesabınız yok mu?',
  'login.registerNow': 'Şimdi kayıt olun',
  'login.requiredFields': '* ile işaretli alanlar zorunludur.',
  'login.emailUsername': '* E-Posta / Kullanıcı Adı',
  'login.password': '* Şifre',
  'login.hidePassword': 'Şifreyi gizle',
  'login.showPassword': 'Şifreyi göster',
  'login.rememberMe': 'Beni hatırla',
  'login.loginButton': 'Giriş Yap',
  'login.pleaseWait': 'Lütfen bekleyin...',
  'login.forgotPassword': 'Şifremi unuttum?',
  'login.shopCustomer': 'Dükkan müşterisi misiniz?',
  'login.activateOnlineAccount': 'Online hesap aktifleştir',
  'login.failed': 'Giriş başarısız',
  'login.invalidCredentials': 'Geçersiz kullanıcı adı veya şifre',

  // Sidebar
  'sidebar.search': 'Takım, Etkinlik veya Turnuva',
  'sidebar.quickAccess': 'Hızlı Erişim',
  'sidebar.topEvents': 'Öne Çıkanlar',
  'sidebar.topKombis': 'Top Kombineler',
  'sidebar.todayMatches': 'Bugünün Maçları',
  'sidebar.germanFootball': 'Alman Futbolu',
  'sidebar.europeanFootball': 'Avrupa Futbolu',
  'sidebar.topCompetitions': 'Popüler Turnuvalar',
  'sidebar.topSports': 'Popüler Sporlar',
  'sidebar.allSports': 'Tüm Sporlar',
  'sidebar.showAllCategories': 'Tüm kategorileri göster',
  'sidebar.hideCategories': 'Kategorileri gizle',

  // Sports
  'sport.football': 'Futbol',
  'sport.tennis': 'Tenis',
  'sport.basketball': 'Basketbol',
  'sport.iceHockey': 'Buz Hokeyi',
  'sport.handball': 'Hentbol',
  'sport.baseball': 'Beyzbol',
  'sport.americanFootball': 'Amerikan Futbolu',
  'sport.boxing': 'Boks',
  'sport.cricket': 'Kriket',
  'sport.darts': 'Dart',
  'sport.rugby': 'Ragbi',
  'sport.tableTennis': 'Masa Tenisi',
  'sport.beachVolleyball': 'Plaj Voleybolu',
  'sport.volleyball': 'Voleybol',
  'sport.esports': 'E-Spor',

  // Market Types
  'market.tip': 'Sonuç',
  'market.tipRemainingTime': 'Kalan Süre',
  'market.firstHalf': 'İlk Yarı',
  'market.overUnder': 'Alt/Üst',
  'market.doubleChance': 'Çifte Şans',
  'market.bothTeamsScore': 'Karşılıklı Gol',

  // Bet Outcomes
  'outcome.fhHomeWinRemainingTime': 'İ.Y. Ev Kazanır Kalan Süre',
  'outcome.fhDrawRemainingTime': 'İ.Y. Berabere Kalan Süre',
  'outcome.fhAwayWinRemainingTime': 'İ.Y. Dep Kazanır Kalan Süre',
  'outcome.fhNextGoalHome': 'İ.Y. Sıradaki Gol Ev',
  'outcome.fhNextGoalAway': 'İ.Y. Sıradaki Gol Dep',
  'outcome.nextGoalHome': 'Sıradaki Gol Ev',
  'outcome.nextGoalAway': 'Sıradaki Gol Dep',
  'market.nextGoal': 'Sıradaki Gol',
  'outcome.home': 'Ev',
  'outcome.away': 'Dep',
  'outcome.homeWin': 'Ev Sahibi Kazanır',
  'outcome.draw': 'Beraberlik',
  'outcome.awayWin': 'Deplasman Kazanır',
  'outcome.over': 'Üst',
  'outcome.under': 'Alt',
  'outcome.yes': 'Evet',
  'outcome.no': 'Hayır',
  'outcome.fhHomeWin': 'İY Ev Sahibi',
  'outcome.fhDraw': 'İY Beraberlik',
  'outcome.fhAwayWin': 'İY Deplasman',
  'outcome.fhOver': 'İY Üst',
  'outcome.fhUnder': 'İY Alt',
  'outcome.homeWinRemainingTime': 'Ev Sahibi (K.S.)',
  'outcome.drawRemainingTime': 'Beraberlik (K.S.)',
  'outcome.awayWinRemainingTime': 'Deplasman (K.S.)',

  // Section Titles
  'section.nextGames': 'Sıradaki Karşılaşmalar',
  'section.topEvents': 'Öne Çıkan Maçlar',
  'section.lastMinute': 'Son Dakika',
  'section.live': 'Canlı',
  'section.next6Hours': 'Önümüzdeki 6 Saat',
  'section.topKombis': 'Top Kombineler',
  'section.topKombisSubtitle': 'diğer kullanıcılardan',
  'section.showAll': 'Tümünü göster',
  'section.viewAll': 'Tümü',

  // Betting Slip
  'slip.title': 'Kupon',
  'slip.empty': 'Kuponunuz henüz boş.',
  'slip.emptyHint': 'Şimdi bahislerinizi seçin.',
  'slip.single': 'Tekli',
  'slip.combi': 'Kombine',
  'slip.system': 'Sistem',
  'slip.stake': 'Bahis Tutarı',
  'slip.totalStake': 'Toplam Bahis',
  'slip.setStake': 'Payı ayarla',
  'slip.totalOdds': 'Toplam Oran',
  'slip.potentialWin': 'Olası Kazanç',
  'slip.placeBet': 'Bahis Yap',
  'slip.openBets': 'Açık Bahisler',
  'slip.viewTicket': 'Kuponu Görüntüle',
  'slip.noOpenBets': 'Açık bahisiniz bulunmamaktadır.',
  'slip.combiBet': 'Kombine Bahis',
  'slip.singleBet': 'Tekli Bahis',
  'slip.singleBets': 'Tekli Bahisler',
  'slip.potentialWinShort': 'Olası Kazanç',
  'slip.maxWin': 'Max. Kazanç',
  'slip.requestCashout': 'Cashout İste',
  'slip.combinations': 'Kombinasyon (Sütun)',
  'slip.cashoutValue': 'Cashout Değeri',
  'slip.confirmCashout': 'Cashout Onayla',
  'slip.errorRequestingQuote': 'Teklif alınırken hata oluştu.',
  'slip.cashoutFailed': 'Cashout başarısız.',
  'slip.error.payoutLimitExceeded': 'Maksimum kazanç limiti aşıldı. Lütfen bahis miktarınızı düşürün.',
  'slip.errorPlacingBet': 'Bahis yapılırken hata oluştu.',
  'slip.placementScore': 'Bahis Anı:',
  'slip.currentScore': 'Güncel:',
  'slip.placingBet': 'Kupon oluşturuluyor...',
  'slip.placingWait': 'Lütfen bekleyin, işlem tamamlanıyor',
  'slip.placingBtn': 'Oluşturuluyor...',
  'slip.betSuccess': 'Kupon Onaylandı',
  'slip.betSuccessDesc': 'Bahisiniz başarıyla yerleştirildi!',
  'slip.hasLockedBets': 'Kuponunuzda kilitli/askıya alınmış bahisler bulunuyor.',

  // Live
  'live.noEvents': 'Canlı etkinlik bulunamadı:',
  'live.games': 'Maç',
  'live.sortBy': 'Sırala:',
  'live.time': 'Zaman',
  'live.competition': 'Turnuva',
  'live.halfTime': 'İlk Yarı',
  'live.ht': 'HT',
  'live.ft': 'FT',

  // Time
  'time.today': 'Bugün',
  'time.tomorrow': 'Yarın',
  'time.minutes': 'Dk',
  'time.hoursShort': 'Sa.',

  // Top Kombis Card
  'kombis.betsPlaced': 'Bahis oynandı',
  'kombis.combi': 'Kombine',
  'kombis.totalOdds': 'Toplam Oran',
  'kombis.tip': 'Tahmin',

  // Account
  'account.myAccount': 'Hesabım',
  'account.loginPrompt': 'Hesabınızı yönetmek için lütfen giriş yapın.',
  'account.verification': 'Hesap Doğrulama',
  'account.management': 'Hesap Yönetimi & Limitler',
  'account.transactions': 'İşlemler',
  'account.personalData': 'Kişisel Bilgiler',
  'account.responsibleGaming': 'Sorumlu Oyun',
  'account.meineDaten': 'Kişisel Bilgiler',
  'account.kontoverifizierung': 'Hesap Doğrulama',
  'account.kontoverwaltung': 'Hesap Yönetimi & Limitler',
  'account.transaktionsverlauf': 'İşlem Geçmişi',
  'account.guthaben': 'Bakiye',
  'account.auszahlung': 'Para Çekme',
  'account.einstellungen': 'Ayarlar',
  'account.neuigkeiten': 'Haberler',
  'account.apps': 'Tipico Uygulamaları',
  'account.kontakt': 'İletişim',
  'account.abmelden': 'Çıkış Yap & Devre Dışı Bırak',
  'account.userTabs.personal': 'Kullanıcı Bilgileri',
  'account.userTabs.contact': 'İletişim Bilgileri',
  'account.userTabs.password': 'Şifre Değiştir',
  'account.fields.name': 'Ad ve Soyad:',
  'account.fields.username': 'Kullanıcı Adı:',
  'account.fields.birthname': 'Soyadı (Doğum Anındaki):',
  'account.fields.birthdate': 'Doğum Tarihi:',
  'account.fields.email': 'E-posta:',
  'account.fields.emailChange': 'E-postayı Değiştir',
  'account.fields.lugasId': 'Lugas Oyuncu Kimliği:',
  'account.underConstruction': 'Bu bölüm henüz yapım aşamasındadır.',
  'account.supportPlaceholder': 'Lütfen talebinizi olabildiğince detaylı açıklayın...',
  'account.salutationMr': 'Bay',
  'account.loginBtn': 'Giriş Yap',
  'account.transactions.title': 'İşlem Geçmişi',
  'account.transactions.type': 'Tür',
  'account.transactions.amount': 'Miktar',
  'account.transactions.status': 'Durum',
  'account.transactions.date': 'Tarih',
  'account.transactions.id': 'Referenz ID',
  'account.transactions.noTransactions': 'Görüntülenecek işlem bulunamadı.',
  'account.transactions.deposit': 'Yatırma',
  'account.transactions.withdrawal': 'Para Çekme',
  'account.transactions.status.completed': 'Tamamlandı',
  'account.transactions.status.pending': 'Beklemede',
  'account.transactions.status.failed': 'Başarısız',
  'account.transactions.filter.all': 'Tümü',
  'account.transactions.filter.startDate': 'Başlangıç:',
  'account.transactions.filter.endDate': 'Bitiş:',
  'account.transactions.filter.reset': 'Sıfırla',
  'account.balance.title': 'Bakiye & Cüzdan',
  'account.balance.total': 'Toplam Bakiye',
  'account.balance.available': 'Kullanılabilir',
  'account.balance.locked': 'Bloke',
  'account.balance.realCash': 'Nakit Bakiye',
  'account.balance.bonusCash': 'Bonus Bakiye',
  'account.balance.premiumWallet': 'Tipico Premium Cüzdan',
  'account.balance.depositAction': 'Bakiye Yükle',
  'account.balance.withdrawAction': 'Para Çek',
  'account.balance.recentActivity': 'Son İşlemler',
  'account.balance.viewAllTransactions': 'Tüm işlemleri görüntüle',
  'account.notifications.title': 'Haberler & Bildirimler',
  'account.notifications.empty': 'Bildirim bulunmamaktadır.',
  'account.notifications.markAllRead': 'Tümünü okundu olarak işaretle',
  'account.notifications.markRead': 'Okundu olarak işaretle',
  'account.notifications.viewAll': 'Tümünü gör',
  'account.withdrawal.title': 'Para Çekme İşlemi',
  'account.withdrawal.selectMethod': 'Para Çekme Yöntemi Seçin:',
  'account.withdrawal.amount': 'Para Çekme Tutarı',
  'account.withdrawal.enterAmount': 'Tutar girin',
  'account.withdrawal.availableToWithdraw': 'Çekilebilir Nakit Bakiye:',
  'account.withdrawal.submit': 'Para Çekme Talebi Gönder',
  'account.withdrawal.processingTime': 'Süre',
  'account.withdrawal.instant': 'Anında',
  'account.withdrawal.bankDays': '1-3 iş günü',
  'account.withdrawal.successMessage': 'Para çekme talebiniz başarıyla iletildi!',
  'account.withdrawal.successSub': 'Tutar kısa süre içinde seçtiğiniz ödeme yöntemine aktarılacaktır.',
  'account.withdrawal.refId': 'Referans ID:',
  'account.withdrawal.error.insufficient': 'Yetersiz nakit bakiye.',
  'account.withdrawal.error.minimum': 'Minimum para çekme tutarı 10 €\'dur.',
  'account.withdrawal.backToWallet': 'Bakiyeye Dön',

  // Login/Register
  'auth.loginTitle': 'Giriş Yap',
  'auth.registerTitle': 'Kayıt Ol',
  'auth.email': 'E-posta',
  'auth.username': 'Kullanıcı Adı',
  'auth.password': 'Şifre',
  'auth.confirmPassword': 'Şifre Tekrar',
  'auth.noAccount': 'Hesabınız yok mu?',
  'auth.hasAccount': 'Zaten hesabınız var mı?',
  'auth.welcomeTitle': 'Spor bahislerinin dünyasına dalın!',
  'auth.bonusTitle': 'İlk yatırımınızı ikiye katlayın',
  'auth.bonusSubtitle': '100 €\'ya kadar',
  'auth.registrationOnlyGermany': 'Kayıt işlemi sadece Almanya\'dan yapılabilir.',

  // My Bets
  'bets.myBets': 'Bahislerim',
  'bets.active': 'Aktif',
  'bets.settled': 'Sonuçlanan',
  'bets.won': 'Kazanan',
  'bets.lost': 'Kaybeden',
  'bets.pending': 'Bekleyen',

  // Misc
  'match.mainBets': 'Ana Bahisler',
  'match.allBets': 'Tüm Bahisler',
  'misc.noOdds': 'Oran yok',
  'misc.matches': 'Maçlar',
  'misc.matchKombi': 'MacKombine+',
  'misc.outrights': 'Şampiyon Bahisleri',
  'misc.statistics': 'İstatistikler',
  'misc.search': 'Ara',
  'misc.close': 'Kapat',
  'misc.back': 'Geri',
  'misc.events': 'Etkinlikler',
  'misc.topCompetitions': 'Popüler Turnuvalar',
  'misc.noMatches': 'Görüntülenecek karşılaşma bulunamadı.',
  'misc.loading': 'Yükleniyor…',
  'misc.confirmColon': 'Onayla:',
  'misc.confirm': 'Onayla',
  'misc.cancel': 'İptal',
  'misc.error': 'Hata.',
};

export default tr;
